const Social = ({ children, href }) => {
  return (
    <a href={href} target='_blank' rel='noreferrer noopener'>
      {children}
    </a>
  );
};
export default Social;
